<script setup lang="ts">
    import { formatDate } from '@cwd/Shared/utils/formatDateTime';
    import { type DomainValidationStatus } from '@cwd/Views/BackOffice/Account/Account.access';
    import Loading from '@shared/components/Loading.vue';

    defineProps<{
        isValidating: boolean;
        validation: DomainValidationStatus | null;
    }>();

    const ValidationState = { Invalid: 0, Valid: 1, Warning: 2 } as const;

    function statusInfo(status: number) {
        if (status === ValidationState.Invalid) return { icon: 'fa-times-circle', color: 'c-danger', text: 'Fail' };
        if (status === ValidationState.Warning) return { icon: 'fa-exclamation-circle', color: 'c-warning', text: 'Warning' };
        return { icon: 'fa-check-circle', color: 'c-success', text: 'Pass' };
    }
</script>

<template>
    <div v-if="isValidating" class="text-center m-lg-b">
        <Loading :show="isValidating"></Loading>
        Validating domain...
    </div>
    <div v-else-if="validation" class="m-lg-b">
        <h4 class="m-xs-b">
            Domain validation for:
            <strong>{{ validation.Domain }}</strong>
            <small class="m-xs-l">(Validated {{ formatDate(validation.ValidatedAt) }})</small>
        </h4>
        <ul class="d-flex col-gap-lg flex-wrap list-unstyled">
            <li>
                <i :class="['fa', statusInfo(validation.SpfStatus).icon, statusInfo(validation.SpfStatus).color]"></i>
                SPF
                <small >({{ statusInfo(validation.SpfStatus).text }})</small>
            </li>
            <li>
                <i :class="['fa', statusInfo(validation.DkimKey1Status).icon, statusInfo(validation.DkimKey1Status).color]"></i>
                DKIM Key1
                <small >({{ statusInfo(validation.DkimKey1Status).text }})</small>
            </li>
            <li>
                <i :class="['fa', statusInfo(validation.DkimUg1Status).icon, statusInfo(validation.DkimUg1Status).color]"></i>
                DKIM Ug1
                <small >({{ statusInfo(validation.DkimUg1Status).text }})</small>
            </li>
            <li>
                <i :class="['fa', statusInfo(validation.DkimUg2Status).icon, statusInfo(validation.DkimUg2Status).color]"></i>
                DKIM Ug2
                <small >({{ statusInfo(validation.DkimUg2Status).text }})</small>
            </li>
            <li>
                <i :class="['fa', statusInfo(validation.DmarcStatus).icon, statusInfo(validation.DmarcStatus).color]"></i>
                DMARC
                <small >({{ statusInfo(validation.DmarcStatus).text }})</small>
            </li>
        </ul>
    </div>
</template>

